import classNames from 'classnames/bind';
import styles from './profile-account-setting-section.module.sass';
import Profile2fa from './profile-2fa';
import { ProfileAccountSettingListItem } from './profile-account-setting-list-item';

const cx = classNames.bind(styles);

export const ProfileAccountSettingSection = ({ user, isMainAccount }) => {
  if (user == null) return null;

  const sectionList = [
    {
      label: '企業帳號',
      value: user.username,
    },
  ];

  if (!isMainAccount) {
    sectionList.push({
      label: '子帳號',
      value: user.subAccount?.username,
    });
  }

  return (
    <section className={cx('container')}>
      <ul className={cx('list')}>
        {sectionList.map((item, index) => (
          <>
            <ProfileAccountSettingListItem
              key={item.label}
              label={item.label}
              value={item.value}
              button={item.button}
            />
            {index < sectionList.length && <div className={cx('divider')} />}
          </>
        ))}
        {isMainAccount && <Profile2fa />}
      </ul>
    </section>
  );
};
